module.exports = __webpack_public_path__ + "img/hide-primary.dc3206fe.svg";